/**
 * [formatStringLowercaseWithDashes]
 * takes a string and makes it lowercase and substitutes spaces for dashes
 * @param  {string}
 * @return {string}
 * eg. ('Air Jordan) -> 'air-jordan'
 * eg. ('new balance) -> 'new-balance'
 * eg. ('Nike') -> 'nike'
 * eg. ('off-white') -> 'off-white'
 */
export const formatStringLowercaseWithDashes = (str: string) => {
  if (!str || typeof str !== 'string') {
    return;
  }

  return str.replace(/\s+/g, '-').toLowerCase();
};
